const ProfileIcon = () => (
	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.84845 12.5254L8.33345 14.5837L5.08595 15.3054C4.77761 15.3737 4.53511 15.6104 4.45845 15.9171L4.15845 17.1154"
			stroke="white"
			strokeWidth="1.5"
			strokeMiterlimit="10"
		/>
		<path
			d="M11.9858 12.5254L12.5 14.5837L15.7475 15.3054C16.0558 15.3737 16.2983 15.6104 16.375 15.9171L16.675 17.1154"
			stroke="white"
			strokeWidth="1.5"
			strokeMiterlimit="10"
		/>
		<path
			d="M13.7499 8.74935C13.7499 6.9084 12.2575 5.41602 10.4166 5.41602C8.57564 5.41602 7.08325 6.9084 7.08325 8.74935V9.58268C7.08325 11.4236 8.57564 12.916 10.4166 12.916C12.2575 12.916 13.7499 11.4236 13.7499 9.58268V8.74935Z"
			stroke="white"
			strokeWidth="1.5"
			strokeMiterlimit="10"
			strokeLinecap="square"
		/>
		<path
			d="M10.4167 19.5833C15.4793 19.5833 19.5833 15.4793 19.5833 10.4167C19.5833 5.35406 15.4793 1.25 10.4167 1.25C5.35406 1.25 1.25 5.35406 1.25 10.4167C1.25 15.4793 5.35406 19.5833 10.4167 19.5833Z"
			stroke="white"
			strokeWidth="1.5"
			strokeMiterlimit="10"
			strokeLinecap="square"
		/>
	</svg>
);

export default ProfileIcon;
